<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount,toRefs,watch } from 'vue'
import CustomList from "../../compositions/CustomList.vue";
import ModalDialog from "../../compositions/ModalDialog.vue";
import SelectBox from "../../compositions/SelectBox.vue";
import TextBox from "../../compositions/TextBox.vue";
import CheckBox from "../../compositions/CheckBox.vue";
import Chart from "../../compositions/Chart.vue";
import OrderHistoryMedicineComponent from "./OrderHistoryMedicineComponent.vue";
import config from "../../config.js";
import { errorAlert } from "../../plugins/alert";
import { getFieldValue } from "../../plugins/utility";
import qs from 'qs';
import axios from '../../plugins/axios.ts';
import moment from "moment";

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    yjCode:{
      type:String,
      default:() => {
        return '';
      },
    },
    historyMedicineName:{
      type:String,
      default:() => {
        return '';
      },
    },
});
const { yjCode } = toRefs(props);
const listMedicineHistoryRef = ref();
const medicineHistoryFields = reactive([
  {field_name: '', field_key: 'data_date', width: '15%', align: 'text-center', sorted:true},
  {field_name: '包装単位', field_key: 'package_label', width: '10%', align: 'text-left', sorted:false},
  {field_name: '取引先', field_key: 'target_name', width: '10%', align: 'text-left', sorted:true},
  {field_name: '分類', field_key: 'warning_mark', width: '5%', align: 'text-center', sorted:true},
  {field_name: '', field_key: 'stock_type', width: '5%', align: 'text-center', sorted:true},
  {field_name: '', field_key: 'action_content', width: '10%', align: 'text-center', sorted:false},
  {field_name: '数量', field_key: 'number', width: '10%', align: 'text-center', sorted:true},
  {field_name: '', field_key: 'action_history_content', width: '10%', align: 'text-center', sorted:false},
  {field_name: '単価', field_key: 'unit_price', width: '5%', align: 'text-center', sorted:true},
  {field_name: '金額', field_key: 'total_price', width: '5%', align: 'text-center', sorted:true},
]);
const optionMedicineHistoryFields = reactive({
  'yj_code' : '',
  'page_size' : 30,
});
watch(yjCode,(newValue,oldValue) => {
  optionMedicineHistoryFields.yj_code = newValue;
  listMedicineHistoryRef.value.resetItem();
});

</script>

<style scoped>
</style>
<template>
<div>
  <div class="mb-2">
      {{ historyMedicineName }}
    </div>
    <div class="w-full">
      <custom-list
        ref="listMedicineHistoryRef"
        :table-fields="medicineHistoryFields"
        :option-fields="optionMedicineHistoryFields"
        :api-url="apis.pharmacy_order_history_list"
        height="72vh"
      >
      <template v-slot:item="slotProps">
        <order-history-medicine-component
          :apis="apis"
          :item="slotProps.item"
          :fields="medicineHistoryFields"
        ></order-history-medicine-component>
      </template>
      </custom-list>
    </div>
</div>
</template>

